// src/utils/env.js
export const isLocal = () => {
  const h = typeof window !== "undefined" ? window.location.hostname : "";
  return (
    h === "localhost" ||
    h === "127.0.0.1" ||
    h === "::1" ||
    h.startsWith("192.168.") ||
    h.endsWith(".local")
  );
};

export const isProdDomain = () => {
  if (typeof window === "undefined") return false;
  const h = window.location.hostname;
  return (
    h.endsWith("everyoungpeople.com") ||
    /\.pages\.dev$/.test(h) ||
    /\.netlify\.app$/.test(h)
  );
};

//  프로덕션: REACT_APP_API_ORIGIN(필수) 사용
//  로컬/개발: REACT_APP_API_BASE 없으면 http://localhost:8080
const PROD_API = (typeof process !== "undefined" && process.env.REACT_APP_API_ORIGIN) || "";
const DEV_API  = (typeof process !== "undefined" && process.env.REACT_APP_API_BASE)   || "http://localhost:8080";

export const API_ORIGIN = isProdDomain() ? PROD_API : DEV_API;
